import React, { useState, useEffect } from 'react'
import * as StringFormatter from '../../../../global/formatters/string-formatter.js'
import { getRelativeBasePath } from '../../../../global/environments/path.js'
import { getModelPortfoliosData } from '../InvestmentProductsDataSource.js'
import ErrorBoundary from '../../.././../components/FundDetails/Modules/Performance/ErrorBoundary.jsx'
import FilterHeader from '../../../../components/PageHeader/FilterHeader.jsx'
import Table from '../../../../components/Table/Table.jsx'
import ModelPortfoliosFilter from './ModelPortfoliosFilter.jsx'
import {
  convertDate,
  lookupCategory,
  lookupIcon,
  stickyOnScroll,
} from '../helpers/InvestmentProductsHelper.js'

import '../InvestmentProducts.css'

export default function ModelPortfoliosContainer() {
  const [funds, setFunds] = useState()
  const [fundsFiltered, setFundsFiltered] = useState([])
  const [selectedFundSearch, setFundSearch] = useState('')
  const [selectedClass, setSelectedClass] = useState()
  const [isFilterOpen, setIsFilterOpen] = useState(false)
  const [isFilterOn, setIsFilterOn] = useState(false)
  const [isFilterOnForced, setIsFilterOnForced] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState({})
  const [selectedFilterCount, setSelectedFilterCount] = useState(0)
  const [tableHeaderTop, setTableHeaderTop] = useState()

  const getFixedDecimal = (val) => {
    return isNaN(Number(val)) ? '--' : Number(val).toFixed(2)
  }

  const getAspect = (section) => {
    const aspects = [
      {
        name: '#modelPortfolios',
        info: {
          selector: [
            {
              name: 'value',
              isArray: false,
            },
            {
              name: 'modelPortfolios',
              isArray: false,
            },
            {
              name: 'portfolioReturns',
              isArray: false,
            },
          ],
          getData: getModelPortfoliosData,
          columnSummaries: [
            {
              name: 'headerSummary0',
              colSpan: 3,
              content: () => '',
            },
            {
              name: 'headerSummary1',
              colSpan: 6,
              content: () => {
                return (
                  <>
                    Average Annual Returns as of{' '}
                    {funds &&
                      funds[0]?.asOfDate &&
                      convertDate(funds[0]?.asOfDate)}
                  </>
                )
              },
            },
          ],
          columns: [
            {
              name: 'returnName',
              className: 'Table-header u-bgColorBrandDark',
              ariaLabel: 'Name',
              content: <div>Model Portfolios</div>,
              cell: {
                className:
                  'u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0',
                content: (fund) => (
                  <a
                    className="u-textBold u-flex u-flexAlignItemsBaseline"
                    style={{ minWidth: 150 }}
                    href={
                      getRelativeBasePath() +
                      `/investment-products/model-portfolios/${StringFormatter.urlSafe(
                        fund.fundName || fund.portfolioName
                      )}/Class-None/details/?cusip=${fund.accountID}`
                    }
                  >
                    {fund.fundName || fund.portfolioName}
                  </a>
                ),
              },
              button: {
                className: 'Table-headerNode u-padding2gu u-paddingRight3gu',
                sort: 'portfolioName' || 'fundName',
                sortType: 'string',
              },
            },
            {
              name: 'inceptionDate',
              className: 'Table-header u-bgColorBrandDark',
              ariaLabel: 'Inception Date',
              content: <div>Inception Date</div>,
              cell: {
                className:
                  'u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-textNoWrap',
                content: (fund) => convertDate(fund.inceptionDt),
              },
              button: {
                className: 'Table-headerNode u-padding2gu u-paddingRight3gu',
                sort: 'inceptionDt',
                sortType: 'date',
              },
            },
            {
              name: 'type',
              className: 'Table-header u-bgColorBrandDark bordered',
              ariaLabel: 'Type',
              cell: {
                className: 'u-borderColorNeutralLight u-borderTop u-textNoWrap',
                content: () => (
                  <>
                    <div className="u-padding2gu u-borderColorNeutralLight">
                      (pure gross)
                    </div>
                    <div className="u-padding2gu">(net)</div>
                  </>
                ),
              },
            },
            {
              name: 'ytd',
              className:
                'Table-header u-bgColorBrandDark u-textCenter u-textNoWrap',
              ariaLabel: 'YTD (cum.)',
              content: <div>YTD (cum.)</div>,
              cell: {
                className:
                  'u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0 u-textNoWrap u-textCenter',
                padding: 'u-paddingHoriz0',
                content: (fund) => (
                  <>
                    <div className="u-padding2gu u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0">
                      {getFixedDecimal(fund.ytdPURE_GROSS)}
                    </div>
                    <div className="u-padding2gu">
                      {getFixedDecimal(fund.ytdNET)}
                    </div>
                  </>
                ),
              },
            },
            {
              name: '1year',
              className:
                'Table-header u-bgColorBrandDark u-textCenter u-textNoWrap',
              ariaLabel: '1 Year',
              content: <div>1 Year</div>,
              cell: {
                className:
                  'u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0 u-textNoWrap u-textCenter',
                padding: 'u-paddingHoriz0',
                content: (fund) => (
                  <>
                    <div className="u-padding2gu u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0">
                      {getFixedDecimal(fund.oneYearPURE_GROSS)}
                    </div>
                    <div className="u-padding2gu">
                      {getFixedDecimal(fund.oneYearNET)}
                    </div>
                  </>
                ),
              },
            },
            {
              name: '3year',
              className:
                'Table-header u-bgColorBrandDark u-textCenter u-textNoWrap',
              ariaLabel: '3 Year',
              content: <div>3 Year</div>,
              cell: {
                className:
                  'u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0 u-textNoWrap u-textCenter',
                padding: 'u-paddingHoriz0',
                content: (fund) => (
                  <>
                    <div className="u-padding2gu u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0">
                      {getFixedDecimal(fund.threeYearPURE_GROSS)}
                    </div>
                    <div className="u-padding2gu">
                      {getFixedDecimal(fund.threeYearNET)}
                    </div>
                  </>
                ),
              },
            },
            {
              name: '5year',
              className:
                'Table-header u-bgColorBrandDark u-textCenter u-textNoWrap',
              ariaLabel: '5 Year',
              content: <div>5 Year</div>,
              cell: {
                className:
                  'u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0 u-textNoWrap u-textCenter',
                padding: 'u-paddingHoriz0',
                content: (fund) => (
                  <>
                    <div className="u-padding2gu u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0">
                      {getFixedDecimal(fund.fiveYearPURE_GROSS)}
                    </div>
                    <div className="u-padding2gu">
                      {getFixedDecimal(fund.fiveYearNET)}
                    </div>
                  </>
                ),
              },
            },
            {
              name: '10year',
              className:
                'Table-header u-bgColorBrandDark u-textCenter u-textNoWrap',
              ariaLabel: '10 Year',
              content: <div>10 Year</div>,
              cell: {
                className:
                  'u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0 u-textNoWrap u-textCenter',
                padding: 'u-paddingHoriz0',
                content: (fund) => (
                  <>
                    <div className="u-padding2gu u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0">
                      {getFixedDecimal(fund.tenYearPURE_GROSS)}
                    </div>
                    <div className="u-padding2gu">
                      {getFixedDecimal(fund.tenYearNET)}
                    </div>
                  </>
                ),
              },
            },
            {
              name: 'since',
              className:
                'Table-header u-bgColorBrandDark u-textCenter u-textNoWrap',
              ariaLabel: 'Since Inception',
              content: <div>Since Inception</div>,
              cell: {
                className:
                  'u-borderColorNeutralLight u-borderTop u-borderBottom0 u-borderLeft0 u-borderRight0 u-textNoWrap u-textCenter',
                padding: 'u-paddingHoriz0',
                content: (fund) => (
                  <>
                    <div className="u-padding2gu u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0">
                      {getFixedDecimal(fund.sinceIncepPURE_GROSS)}
                    </div>
                    <div className="u-padding2gu">
                      {getFixedDecimal(fund.sinceIncepNET)}
                    </div>
                  </>
                ),
              },
            },
          ],
        },
      },
    ]

    return aspects.find((a) => a.name === section).info
  }

  useEffect(() => {
    initializeFunds()
    stickyOnScroll(setTableHeaderTop)
  }, [])

  useEffect(() => {
    initializeFundsFiltered()
  }, [selectedFundSearch, selectedFilter, funds])

  useEffect(() => {
    document
      .querySelectorAll('.Article-container')
      .forEach((c) => c.classList.remove('u-hidden'))
  }, [])

  const initializeFundsFiltered = (fundsArray) => {
    const _funds = fundsArray || funds

    const selectedCategoriesLength =
      (selectedFilter.categories && selectedFilter.categories.length) || 0
    const selectedGoalsLength =
      (selectedFilter.goals && selectedFilter.goals.length) || 0
    const selectedTypesLength =
      (selectedFilter.types && selectedFilter.types.length) || 0

    const selectedTypes = selectedTypesLength > 0 && selectedFilter.types
    const selectedCategories =
      selectedCategoriesLength > 0 && selectedFilter.categories
    const selectedGoals = selectedGoalsLength > 0 && selectedFilter.goals

    const isFundMatch = (filters, types) => {
      return types.some((type) => {
        for (const filter of filters) {
          for (const value of filter.filterValue) {
            if (type === value.code) {
              return true
            }
          }
        }
      })
    }

    if (
      selectedFundSearch ||
      selectedCategories ||
      selectedGoals ||
      selectedTypes
    ) {
      const _fundsFiltered = _funds.filter((fund) => {
        // Search
        const fundSearchTest =
          !selectedFundSearch ||
          fund.fundName
            .toLowerCase()
            .indexOf(selectedFundSearch.toLowerCase()) > -1

        // Type
        const typeTest =
          !selectedTypes || isFundMatch(fund.filters, selectedTypes)

        // Category
        const categoryTest =
          !selectedCategories || isFundMatch(fund.filters, selectedCategories)

        // Goal
        const goalTest =
          !selectedGoals || isFundMatch(fund.filters, selectedGoals)

        // Does fund meet all tests?
        return fundSearchTest && typeTest && categoryTest && goalTest
      })

      setIsFilterOn(true)

      setSelectedFilterCount(
        selectedCategoriesLength + selectedGoalsLength + selectedTypesLength
      )

      setFundsFiltered(_fundsFiltered)
    } else {
      setIsFilterOn(false)

      setSelectedFilterCount(0)

      setFundsFiltered([])
    }
  }

  const initializeFunds = async () => {
    const aspect = getAspect('#modelPortfolios')

    const data = await aspect.getData()

    const _classes = data?.value?.modelPortfolios

    if (
      _classes.filterInfo &&
      _classes.filterInfo.find(
        (filter) => filter.filterName === 'Risk Tolerance'
      )
    ) {
      _classes.filterInfo
        .find((filter) => filter.filterName === 'Risk Tolerance')
        .filterValues.sort((a, b) => a.code.localeCompare(b.code))
    }

    setSelectedClass(_classes)

    const _funds = aspect.selector.reduce(
      (prev, curr) => (curr.isArray ? prev[curr.name][0] : prev[curr.name]),
      data
    )

    const combinedFunds = combineNetAndPureGrossData(_funds)
    setFunds(combinedFunds)
  }

  const combineNetAndPureGrossData = (funds) => {
    return funds.reduce((acc, current) => {
      const foundFund = acc.find(
        (fund) =>
          fund.fundName === current.fundName && fund.type !== current.type
      )
      if (foundFund) {
        addProperties(foundFund, current)
        const propertiesToDelete = [
          'ytd',
          'oneYear',
          'threeYear',
          'fiveYear',
          'tenYear',
          'sinceIncep',
          'type',
        ]
        propertiesToDelete.forEach((prop) => delete foundFund[prop])
      } else {
        const newObj = {
          ...current,
        }
        addProperties(newObj, current)
        acc.push(newObj)
      }
      return acc
    }, [])
  }

  const addProperties = (target, source) => {
    const metrics = [
      'ytd',
      'oneYear',
      'threeYear',
      'fiveYear',
      'tenYear',
      'sinceIncep',
    ]
    metrics.forEach((metric) => {
      target[metric + source.type] = source[metric]
    })
  }

  const onClickToggleFilter = (type) => {
    if (type) {
      setIsFilterOpen(!isFilterOpen)
    }

    setIsFilterOnForced(false)
  }

  const onChangeFundSearch = (event) => {
    setFundSearch(event.currentTarget.value)
  }

  const onChangeFilter = (filter) => {
    setSelectedFilter(filter)

    setIsFilterOnForced(false)
  }

  const aspect = getAspect('#modelPortfolios')

  const _funds = (isFilterOn || isFilterOnForced ? fundsFiltered : funds) || []

  return (
    <div className="investment-products model-portfolio-scope u-marginBottom5gu">
      <ErrorBoundary
        title="Model Portfolios"
        message="Model Portfolios information is currently unavailable due to a technical issue. Please try again later."
        isConstrained={true}
      >
        <div id="model-portfolios" className="u-paddingVert2gu">
          <div className="u-sizeConstrained Content u-marginBottom5gu">
            <div className="u-posRelative u-bgColorLight">
              <FilterHeader
                title="Filters"
                placeholder="Find a Portfolio"
                count={selectedFilterCount}
                defaultSearchText={selectedFundSearch}
                isOpen={isFilterOpen}
                onClick={() => onClickToggleFilter(1)}
                onSearch={onChangeFundSearch}
                mode="product-landing on-key-press"
                noAutoComplete={true}
              />
              <div
                className={`InvestmentProductsFilterDropDown is-model-portfolios u-bgColorLight u-posAbsolute u-zIndexTier1 ${
                  isFilterOpen ? '' : 'u-hidden'
                } `}
              >
                <ModelPortfoliosFilter
                  selectedClass={selectedClass}
                  selectedFilter={selectedFilter}
                  onChange={onChangeFilter}
                  onClose={() => onClickToggleFilter(1)}
                  lookupCategory={lookupCategory}
                  lookupIcon={lookupIcon}
                />
              </div>
            </div>
            {!isFilterOnForced && (
              <div className="u-flex u-flexAlignItemsCenter u-marginTop4gu u-marginBottom2gu">
                <div className="Form-label u-flexAuto">
                  Displaying{' '}
                  <span className="u-textBold">
                    {isFilterOn || isFilterOnForced
                      ? (fundsFiltered && fundsFiltered.length) || 0
                      : (funds && funds.length) || 0}
                  </span>{' '}
                  portfolio(s)
                </div>
              </div>
            )}
            <div className="InvestmentProductTable">
              <Table
                columns={aspect.columns}
                rows={_funds}
                columnSummaries={aspect.columnSummaries}
                tableClass="u-sm-block u-overflowX"
                mode={'no-stripe'}
                scrollOffset={tableHeaderTop}
              />
            </div>
          </div>
        </div>
      </ErrorBoundary>
    </div>
  )
}
